import fy2Api from '@/api/fy2Api';
import BaseModule from "@/common/BaseModule";
import { Module } from "vuex";
import { LOAD_CHANNELS_ROOT, LOAD_CHANNELS_SHORT, SEO, LOAD_MINE_FAVORITES } from '../protocols';

export interface State {
    id: number,
    isFavorite: boolean,
    tag: string,
    tags: ShortVideoTag[],
    videoList: ShortVideo[],
    video: ShortVideo,
}

class ChannelsShort extends BaseModule<State> {
    constructor() {
        super(LOAD_CHANNELS_SHORT[0])
    }

    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                id: 0,
                isFavorite: false,
                tag: '',
                tags: [],
                videoList: [],
                video: {
                    id: 0,
                    title: '',
                    thumb: '',
                } as ShortVideo
            },
            actions: {
                async loadTags({ state }) {
                    if (state.tags.length == 0) {
                        state.tags = await fy2Api.getShortTags()
                    }
                },
                async loadLives({ state, rootState }, route: Route) {
                    let reload = state.videoList.length == 0
                    let tag = route.query.tag
                    let id = parseInt(route.query.id)
                    if (id > 0) {
                        state.id = id
                        state.isFavorite = rootState[LOAD_MINE_FAVORITES[0]].shorts.some((item: any) => item.vid == state.id)
                        state.video = await fy2Api.getShortVideo(id)
                        if (state.tag != state.video.tag) {
                            state.tag = state.video.tag
                            reload = true
                        }
                    } else if (state.tag != tag) {
                        state.tag = tag
                        state.video = {
                            id: 0,
                            title: '',
                            thumb: '',
                        } as ShortVideo
                        reload = true
                    }
                    if (reload) {
                        let { list, count } = await fy2Api.getShortVideos(1, 100, state.tag)
                        state.videoList = list
                    }
                    if (state.video.id == 0 && state.videoList.length > 0) {
                        let i = Math.floor(Math.random() * state.videoList.length)
                        state.id = state.videoList[i].id
                        state.isFavorite = rootState[LOAD_MINE_FAVORITES[0]].shorts.some((item: any) => item.vid == state.id)
                        state.video = await fy2Api.getShortVideo(state.id)
                    }
                },
                async refreshFavorite({ state, rootState }) {
                    if (state.id > 0) {
                        state.isFavorite = rootState[LOAD_MINE_FAVORITES[0]].shorts.some((item: any) => item.vid == state.id)
                    }
                },
                [LOAD_CHANNELS_SHORT[1]]({ dispatch, commit }, route: Route) {
                    const seoTitle = '短视频-频道-福音影视网|福音TV'
                    commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    return Promise.all([
                        dispatch(LOAD_CHANNELS_ROOT[0] + '/loadLeft', {}, { root: true }),
                        dispatch('loadTags', route),
                        dispatch('loadLives', route),
                    ])
                }
            }
        }
    }
}

export default new ChannelsShort()